import Sidebar from "../components/Sidebar";
import Topbar from "../components/Topbar";
import {
  ShieldCheck,
  Code2,
  GraduationCap,
  BarChart3,
  Trophy,
} from "lucide-react";

export default function Home() {
  return (
    <div className="min-h-screen bg-gray-950">
      {/* SIDEBAR IS FIXED */}
      <Sidebar />

      {/* MAIN CONTENT */}
      <div className="ml-64 min-h-screen bg-gradient-to-br from-gray-950 via-gray-900 to-black text-gray-200">
        <Topbar title="StudyPortal" />

        {/* HERO SECTION */}
        <section className="px-12 pt-16 pb-24">
          <h1 className="text-5xl font-extrabold text-white leading-tight max-w-4xl">
            Learn. Code. Compete.
            <br />
            <span className="text-indigo-400">
              Secure Coding Platform for Students
            </span>
          </h1>

          <p className="mt-6 text-lg text-gray-400 max-w-3xl">
            StudyPortal empowers school, college, and university students with
            a secure environment for coding, testing, and hands-on learning.
            Designed for real exams, real skills, and real performance.
          </p>

          <div className="mt-8 flex gap-4">
            <button className="px-6 py-3 bg-indigo-600 hover:bg-indigo-700 transition rounded-xl text-white font-semibold shadow-lg">
              🚀 Start Learning
            </button>
            <button className="px-6 py-3 border border-gray-600 hover:border-indigo-500 transition rounded-xl text-gray-300">
              🧪 Explore Labs
            </button>
          </div>
        </section>

        {/* FEATURES */}
        <section className="px-12 pb-24">
          <h2 className="text-3xl font-bold text-white mb-12">
            Why Students & Colleges Choose StudyPortal
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-8">
            <FeatureCard
              icon={<ShieldCheck size={30} />}
              title="Secure Code Execution"
              desc="Run Python, Java, and C++ inside fully isolated Docker sandboxes with strict time and memory limits."
            />

            <FeatureCard
              icon={<Code2 size={30} />}
              title="Hands-on Coding Labs"
              desc="Practice exam-style problems, real-world coding tasks, and compiler-based challenges."
            />

            <FeatureCard
              icon={<GraduationCap size={30} />}
              title="University & Exam Ready"
              desc="Perfect for KTU, internal exams, lab evaluations, and skill assessments."
            />

            <FeatureCard
              icon={<BarChart3 size={30} />}
              title="Performance Analytics"
              desc="Track execution time, errors, progress, and improvement with detailed insights."
            />

            <FeatureCard
              icon={<Trophy size={30} />}
              title="Competitive Leaderboards"
              desc="Motivate students with rankings, contests, achievements, and badges."
            />

            <FeatureCard
              icon={<ShieldCheck size={30} />}
              title="Enterprise-Grade Security"
              desc="Built with isolation-first architecture to prevent cheating and system abuse."
            />
          </div>
        </section>

        {/* CTA */}
        <section className="px-12 pb-32">
          <div className="bg-gradient-to-r from-indigo-600 to-purple-600 rounded-2xl p-14 text-center shadow-2xl">
            <h2 className="text-4xl font-bold text-white mb-4">
              Built for Students. Trusted by Institutions.
            </h2>
            <p className="text-indigo-100 max-w-2xl mx-auto mb-8">
              Whether you're preparing for exams, improving coding skills, or
              managing academic labs — StudyPortal scales with your learning
              journey.
            </p>

            <button className="px-8 py-4 bg-black/40 hover:bg-black/60 transition rounded-xl text-white font-semibold">
              Get Started Now
            </button>
            
          </div>
        </section>
        {/* ================= FOOTER ================= */}
<footer className="border-t border-gray-800 bg-gray-950 px-12 py-10">
  <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-8 text-gray-400">

    {/* BRAND */}
    <div>
      <h3 className="text-xl font-bold text-white mb-3">
        Founder
      </h3>
      <p className="text-sm leading-relaxed">
       <li>Shubham kumar</li>
       <li>Btech Cse(Cyber Security)</li>
       <li>📧 shubhamkumar47746@gmail.com</li>
      </p>
    </div>

    {/* CONTACT */}
    <div>
      <h4 className="text-lg font-semibold text-white mb-3">
        Contact
      </h4>
      <ul className="space-y-2 text-sm">
        <li>📞 +91 92638 84942</li>
        <li>📧 kumarshubham35668@gmail.com</li>
      </ul>
    </div>

    {/* ADDRESS */}
    <div>
      <h4 className="text-lg font-semibold text-white mb-3">
        Address
      </h4>
      <p className="text-sm leading-relaxed">
        Vadodara, Gujarat<br />
        Umacharrasta – 391760<br />
        India
      </p>
    </div>
  </div>

  {/* BOTTOM BAR */}
  <div className="mt-10 pt-6 border-t border-gray-800 text-center text-sm text-gray-500">
    © {new Date().getFullYear()} StudyPortal. All rights reserved.
  </div>
</footer>

      </div>
      
    </div>
  );
}

function FeatureCard({ icon, title, desc }) {
  return (
    <div className="bg-gray-900/70 backdrop-blur border border-gray-800 rounded-2xl p-6 hover:border-indigo-500 transition shadow-lg">
      <div className="text-indigo-400 mb-4">{icon}</div>
      <h3 className="text-xl font-semibold text-white mb-2">
        {title}
      </h3>
      <p className="text-gray-400 text-sm leading-relaxed">
        {desc}
      </p>
    </div>
  );
}
